import { useTheme } from 'next-themes';
import { Moon, Sun } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useEffect, useState } from 'react';

export function ThemeToggle() {
  const { theme, setTheme } = useTheme();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) return null;

  const isOnyx = theme === 'onyx';

  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={() => setTheme(isOnyx ? 'aurora' : 'onyx')}
      title={`Switch to ${isOnyx ? 'Aurora' : 'Onyx'} theme`}
      className="rounded-full w-9 h-9 opacity-70 hover:opacity-100 transition-opacity"
    >
      {isOnyx ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
      <span className="sr-only">Toggle theme</span>
    </Button>
  );
}
